import { Chip } from '@mui/material';
import { IconMan, IconWoman } from '@tabler/icons';
import {
	Gender,
	genderEnumOptions,
} from 'modules/EndUsersManagement/constants/enums';
import getEnumOptionLabel from 'modules/shared/utils/getEnumOptionLabel';
import React, { FC } from 'react';

const GenderColumn: FC<{ gender: Gender }> = ({ gender }) => {
	return (
		<Chip
			icon={gender === Gender.FEMALE ? <IconWoman /> : <IconMan />}
			label={getEnumOptionLabel(genderEnumOptions, gender)}
			variant='outlined'
		/>
	);
};

export default GenderColumn;
